import { BankSlipErrorType } from './type'
import Visual from './Visual'

const BankSlipError = ({ orderId, user }: BankSlipErrorType) => {
  return <Visual orderId={orderId} user={user}/>
}

export default BankSlipError
